import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { InventoryList } from "./inventory-list/InventoryList";
import { inventorySnapshotRoute } from "./inventory-snapshot/inventorySnapshot.routes";
import { INVENTORY_LIST_PATH, INVENTORY_LIST_SEGMENT, INVENTORY_SEGMENT } from "./inventory.paths";

/** The inventory feature's routes: the list (bare /inventory redirects to it) and the snapshots page. */
export const inventoryRoute: RouteObject = {
  path: INVENTORY_SEGMENT,
  children: [
    { index: true, element: <Navigate replace to={INVENTORY_LIST_PATH} /> },
    { path: INVENTORY_LIST_SEGMENT, element: <InventoryList /> },
    inventorySnapshotRoute,
  ],
};
